import $ from 'jquery';
import moment from 'moment';
import 'bootstrap';
//import 'select2'; //this does not import the full version of select2, we need to use the require statement below to accomplish that
require("select2/dist/js/select2.full.js");

import Vue from 'vue'
import i18n from './i18n';

import BootstrapVue from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
localize('en', en);
import axios from 'axios';
import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import Visibility from 'visibilityjs';

import EnumPlugin from './plugins/EnumPlugin';
import ConfigPlugin from './plugins/ConfigPlugin';
import UrlHelperPlugin from './plugins/UrlHelperPlugin';
import EJ2Plugin from './plugins/EJ2Plugin';
import I18NPlugin from './plugins/I18NPlugin';
import LogPlugin from './plugins/LogPlugin';

import ErrorsMixin from './mixins/ErrorsMixin';
import DateTimeMixin from './mixins/DateTimeMixin';
import UuidMixins from './mixins/UuidMixins';
import TranscriptMixins from './mixins/TranscriptMixins';

import Select2 from './components/Select2';
import StickyPanel from './components/StickyPanel';

import NotificationIcon from './components/Notification/NotificationIcon.vue'
import ContactManagement from './components/ContactManagement.vue'
import Rates from './components/Rates.vue'
import NotificationList from './components/NotificationList.vue'
import NotificationLanding from './components/NotificationLanding.vue'
import NotificationSettings from './components/NotificationSettings.vue'
import OrdersGrid from './components/Grid/OrdersGrid.vue'
import ContactSelect from './components/ContactSelect.vue'
import CourtMatterSelect from './components/CourtMatterSelect.vue'
import CourtMatterDetails from './components/CourtMatterDetails.vue'
import CourtAppearances from './components/CourtAppearances.vue'
import CourtSittings from './components/CourtSittings.vue'
import NonProductionCharges from './components/NonProductionCharges.vue'
import Attachments from './components/Attachments.vue'
import Contacts from './components/Contacts.vue'
import ValidationSummary from './components/ValidationSummary.vue'
import OrderPayments from './components/OrderPayments.vue'
import Comments from './components/Comments.vue'
import InterviewParties from './components/InterviewParties.vue'
import ListCourtOrderDetails from './components/OrderDetails/ListCourtOrderDetails.vue'
import PaymentsGrid from './components/Grid/PaymentsGrid.vue'
import FiservDirectPost from './components/Payment/FiservDirectPost.vue'
import QuotesGrid from './components/Grid/QuotesGrid.vue'
import QuoteEdit from './components/QuoteEdit.vue'
import QuoteNew from './components/QuoteNew.vue'
import QuoteNewSimple from './components/QuoteNewSimple.vue'
import BatchReportGrid from './components/Grid/BatchReportGrid.vue'
import OrdersReportGrid from './components/Grid/OrdersReportGrid.vue'
import WorkItemsReportGrid from './components/Grid/WorkItemsReportGrid.vue'
import AvailabilityCalendar from './components/Availability/AvailabilityCalendar.vue'
import AvailabilityTemplate from './components/Availability/AvailabilityTemplate.vue'
import AvailabilityWeeksAccumulated from './components/Availability/AvailabilityWeeksAccumulated.vue'

import AssignmentConfirmationPanel from './components/Availability/AssignmentConfirmationPanel.vue'

import TopscribeEditor from './components/TOPScribe/TopscribeEditor.vue'
import WorkItemsGrid from './components/Grid/WorkItemsGrid.vue'
import CourtSittingDetails from './components/CourtSittingDetails.vue'
import InterviewDetails from './components/InterviewDetails.vue'
import WorkitemOrders from './components/WorkitemOrders.vue'
import StaffWorkitemAssignments from './components/StaffWorkitemAssignments.vue'
import WorkitemAttachments from './components/WorkitemAttachments.vue'
import TranscriptWorksheet from './components/Worksheet/TranscriptWorksheet.vue'
import RecordingWorksheet from './components/Worksheet/RecordingWorksheet.vue'
import GenericWorksheet from './components/Worksheet/GenericWorksheet.vue'
import ListCourtWorksheet from './components/Worksheet/ListCourtWorksheet.vue'
import RealtimeWorksheet from './components/Worksheet/RealtimeWorksheet.vue'
import RecordedSegments from './components/RecordedSegments.vue'
import TranscriptSupplyonlyWorksheet from './components/Worksheet/TranscriptSupplyonlyWorksheet.vue'
import TurnTranscriptWorkitems from './components/TurnTranscriptWorkitems.vue'
import InterviewOrderDetails from './components/OrderDetails/InterviewOrderDetails.vue'
import CourtOrderDetails from './components/OrderDetails/CourtOrderDetails.vue'
import AsrRequestsGrid from './components/Grid/AsrRequestsGrid.vue'
import NotificationWidget from './components/Dashboard/Widgets/NotificationWidget.vue'
import CourtOrderRequestDetails from './components/OrderRequestDetails/CourtOrderRequestDetails.vue'
import InterviewOrderRequestDetails from './components/OrderRequestDetails/InterviewOrderRequestDetails.vue'
import OrderRequestsGrid from './components/Grid/OrderRequestsGrid.vue'
import Dashboard from './components/Dashboard/Dashboard.vue'
import ServiceHealthWidget from './components/Dashboard/Widgets/ServiceHealthWidget.vue'
import UsersInfoWidget from './components/Dashboard/Widgets/UsersInfoWidget.vue'
import PaymentsWidget from './components/Dashboard/Widgets/PaymentsWidget.vue'
import OrdersWidget from './components/Dashboard/Widgets/OrdersWidget.vue'
import ClientOrdersWidget from './components/Dashboard/Widgets/ClientOrdersWidget.vue'
import AvailabilityWidget from './components/Dashboard/Widgets/AvailabilityWidget.vue'
import ServiceTimelineWidget from './components/Dashboard/Widgets/ServiceTimelineWidget.vue'
import CaseCategoryWidget from './components/Dashboard/Widgets/CaseCategoryWidget.vue'

import CostingAveragesWidget from './components/Dashboard/Widgets/CostingAveragesWidget.vue'
import CostingTotalsWidget from './components/Dashboard/Widgets/CostingTotalsWidget.vue'

import TranscriptionWordcountWidget from './components/Dashboard/Widgets/TranscriptionWordcountWidget.vue'
import WorksheetsWidget from './components/Dashboard/Widgets/WorksheetsWidget.vue'
import HearingsWidget from './components/Dashboard/Widgets/HearingsWidget.vue'
import FileUpload from './components/FileUpload.vue'
import BlankAudioSegments from './components/BlankAudioSegments.vue'
import ClientBranches from './components/ClientBranches.vue'
import ElectronicGlossary from './components/ElectronicGlossary.vue'
import DataRetentionGrid from './components/Grid/DataRetentionGrid.vue'
import DataRetentionExecutionGridRow from './components/Grid/DataRetentionExecutionGridRow.vue';
import PublicHolidays from './components/PublicHolidays.vue'
import Diary from './components/Diary/Diary.vue'
import ClientSelect from './components/ClientSelect.vue'
import BranchSelect from './components/BranchSelect.vue'
import CourtQuoteDetails from './components/QuoteDetails/CourtQuoteDetails.vue'
import InterviewQuoteDetails from './components/QuoteDetails/InterviewQuoteDetails.vue'

import BillingManagementGrid from './components/Grid/BillingManagementGrid.vue'
import LogNotesModal from './components/LogNotesModal.vue'
import UsersGrid from './components/Grid/UsersGrid.vue'
import GlossaryEntryCategoryGrid from './components/Grid/GlossaryEntryCategoryGrid.vue'
import PrintQueue from './components/PrintQueue.vue'
import PrintQueueModal from './components/PrintQueueModal.vue'

import { registerLicense } from '@syncfusion/ej2-base';

import './default.scss';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1ednVdRWJZU0B3WEQ=');

Vue.config.productionTip = false;
Vue.use(BootstrapVue)
Vue.use(DateTimePickerPlugin);

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
Vue.component('select2', Select2);
Vue.component('sticky-panel', StickyPanel);

Vue.component('notification-icon', NotificationIcon);
Vue.component('contact-management', ContactManagement);
Vue.component('rates', Rates);
Vue.component('notification-list', NotificationList);
Vue.component('notification-landing', NotificationLanding);
Vue.component('notification-settings', NotificationSettings);
Vue.component('orders-grid', OrdersGrid);
Vue.component('contact-select', ContactSelect);
Vue.component('court-matter-select', CourtMatterSelect);
Vue.component('court-matter-details', CourtMatterDetails);
Vue.component('court-appearances', CourtAppearances);
Vue.component('court-sittings', CourtSittings);
Vue.component('non-production-charges', NonProductionCharges);
Vue.component('attachments', Attachments);
Vue.component('contacts', Contacts);
Vue.component('validation-summary', ValidationSummary);
Vue.component('order-payments', OrderPayments);
Vue.component('comments', Comments);
Vue.component('interview-parties', InterviewParties);
Vue.component('list-court-order-details', ListCourtOrderDetails);
Vue.component('payments-grid', PaymentsGrid);
Vue.component('fiserv-direct-post', FiservDirectPost);
Vue.component('quotes-grid', QuotesGrid);
Vue.component('edit-quote', QuoteEdit);
Vue.component('new-quote', QuoteNew);
Vue.component('new-quote-simple', QuoteNewSimple);
Vue.component('batch-report-grid', BatchReportGrid);
Vue.component('orders-report-grid', OrdersReportGrid);
Vue.component('work-items-report-grid', WorkItemsReportGrid);
Vue.component('availability-calendar', AvailabilityCalendar);
Vue.component('availability-template', AvailabilityTemplate);
Vue.component('availability-weeks-accumulated', AvailabilityWeeksAccumulated);

Vue.component('assignment-confirmation-panel', AssignmentConfirmationPanel);

Vue.component('topscribe-editor', TopscribeEditor);
Vue.component('work-items-grid', WorkItemsGrid);
Vue.component('court-sitting-details', CourtSittingDetails);
Vue.component('interview-details', InterviewDetails);
Vue.component('workitem-orders', WorkitemOrders);
Vue.component('staff-workitem-assignments', StaffWorkitemAssignments);
Vue.component('workitem-attachments', WorkitemAttachments);
Vue.component('transcript-worksheet', TranscriptWorksheet);
Vue.component('recording-worksheet', RecordingWorksheet);
Vue.component('generic-worksheet', GenericWorksheet);
Vue.component('list-court-worksheet', ListCourtWorksheet);
Vue.component('realtime-worksheet', RealtimeWorksheet);
Vue.component('recorded-segments', RecordedSegments);
Vue.component('transcript-supplyonly-worksheet', TranscriptSupplyonlyWorksheet);
Vue.component('turn-transcript-workitems', TurnTranscriptWorkitems);
Vue.component('interview-order-details', InterviewOrderDetails);
Vue.component('court-order-details', CourtOrderDetails);
Vue.component('asr-requests-grid', AsrRequestsGrid);
Vue.component('notification-widget', NotificationWidget);
Vue.component('court-order-request-details', CourtOrderRequestDetails);
Vue.component('interview-order-request-details', InterviewOrderRequestDetails);
Vue.component('order-requests-grid', OrderRequestsGrid); 
Vue.component('service-health-widget', ServiceHealthWidget);
Vue.component('users-info-widget', UsersInfoWidget);
Vue.component('payments-widget', PaymentsWidget);
Vue.component('orders-widget', OrdersWidget);
Vue.component('client-orders-widget', ClientOrdersWidget);
Vue.component('availability-widget', AvailabilityWidget);
Vue.component('service-timeline-widget', ServiceTimelineWidget);
Vue.component('transcription-wordcount-widget', TranscriptionWordcountWidget);
Vue.component('case-category-widget', CaseCategoryWidget);

Vue.component('costing-averages-widget', CostingAveragesWidget);
Vue.component('costing-totals-widget', CostingTotalsWidget);

Vue.component('worksheets-widget', WorksheetsWidget);
Vue.component('hearings-widget', HearingsWidget);
Vue.component('dashboard', Dashboard);
Vue.component('file-upload', FileUpload);
Vue.component('blank-audio-segments', BlankAudioSegments);
Vue.component('client-branches', ClientBranches);
Vue.component('electronic-glossary', ElectronicGlossary);
Vue.component('data-retention-grid', DataRetentionGrid);
Vue.component('data-retention-execution-grid-row', DataRetentionExecutionGridRow);
Vue.component('public-holidays', PublicHolidays);
Vue.component('diary', Diary);
Vue.component('clientSelect', ClientSelect);
Vue.component('branchSelect', BranchSelect);
Vue.component('courtQuoteDetails', CourtQuoteDetails);
Vue.component('interviewQuoteDetails', InterviewQuoteDetails);

Vue.component('billing-management-grid', BillingManagementGrid);
Vue.component('log-notes-modal', LogNotesModal);
Vue.component('print-queue', PrintQueue);
Vue.component('print-queue-modal', PrintQueueModal);

Vue.component('users-grid', UsersGrid);
Vue.component('glossary-entry-category-grid', GlossaryEntryCategoryGrid);


window.$ = $;
window.jQuery = $;
window.moment = moment;
window.i18n = i18n;
window.Vue = Vue;
window.axios = axios;
window.Visibility = Visibility;

window.EnumPlugin = EnumPlugin;
window.ConfigPlugin = ConfigPlugin;
window.UrlHelperPlugin = UrlHelperPlugin;
window.EJ2Plugin = EJ2Plugin;
window.I18NPlugin = I18NPlugin;
window.LogPlugin = LogPlugin;

window.ErrorsMixin = ErrorsMixin;
window.DateTimeMixin = DateTimeMixin;
window.UuidMixins = UuidMixins;
window.TranscriptMixins = TranscriptMixins;